module.exports = __webpack_public_path__ + "static/media/hoc1.4aa4549d.jpg";